/*
  Brand banner carousel. Loops round in both directions (last slide goes on to the first, and back).
  Works without JavaScript as a single banner. Respects reduced motion.
*/
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.hasAttribute('data-ibb-ready')) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('.indicator-brand-banner__slide'));
    if (slides.length < 2) return;
    root.setAttribute('data-ibb-ready', '');
    root.classList.add('is-ready');

    var viewport = root.querySelector('.indicator-brand-banner__viewport');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ibb-dot]'));
    var prevBtn = root.querySelector('[data-ibb-prev]');
    var nextBtn = root.querySelector('[data-ibb-next]');
    var pauseBtn = root.querySelector('[data-ibb-pause]');
    var inEditor = window.Shopify && window.Shopify.designMode;
    var seconds = inEditor || reduceMotion ? 0 : parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    var n = slides.length;
    var current = 0;
    var busy = false;
    var timer = null;
    var userPaused = false;

    viewport.style.touchAction = 'pan-y';
    viewport.setAttribute('aria-live', seconds ? 'off' : 'polite');

    function setHidden(slide, hidden) {
      slide.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      if (hidden) slide.setAttribute('inert', '');
      else slide.removeAttribute('inert');
    }
    slides.forEach(function (s, k) {
      s.classList.toggle('is-active', k === 0);
      setHidden(s, k !== 0);
    });

    function syncDots() {
      dots.forEach(function (d, k) { d.setAttribute('aria-selected', k === current ? 'true' : 'false'); });
    }

    function go(target, dir) {
      target = (target + n) % n;
      if (target === current || busy) return;
      if (dir === undefined) dir = target > current ? 1 : -1;
      var out = slides[current];
      var inn = slides[target];
      current = target;
      syncDots();

      if (reduceMotion) {
        out.classList.remove('is-active');
        setHidden(out, true);
        inn.classList.add('is-active');
        setHidden(inn, false);
        return;
      }

      busy = true;
      setHidden(inn, false);
      inn.style.transition = 'none';
      inn.style.transform = 'translateX(' + dir * 100 + '%)';
      inn.classList.add('is-animating');
      out.classList.add('is-animating');
      void inn.offsetWidth; // let the starting position register before animating
      inn.style.transition = '';
      inn.style.transform = 'translateX(0)';
      out.style.transform = 'translateX(' + -dir * 100 + '%)';

      var finished = false;
      function finish() {
        if (finished) return;
        finished = true;
        out.classList.remove('is-animating', 'is-active');
        out.style.transform = '';
        setHidden(out, true);
        inn.classList.remove('is-animating');
        inn.classList.add('is-active');
        inn.style.transform = '';
        busy = false;
      }
      inn.addEventListener('transitionend', function onEnd(e) {
        if (e.target !== inn) return;
        inn.removeEventListener('transitionend', onEnd);
        finish();
      });
      window.setTimeout(finish, 900);
    }

    /* Arrows and dots */
    if (prevBtn) prevBtn.addEventListener('click', function () { go(current - 1, -1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(current + 1, 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    syncDots();

    /* Keyboard */
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(current - 1, -1);
      else if (e.key === 'ArrowRight') go(current + 1, 1);
    });

    /* Swipe */
    var startX = 0, startY = 0, tracking = false, swiped = false;
    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      tracking = true; swiped = false; startX = e.clientX; startY = e.clientY;
    });
    viewport.addEventListener('pointerup', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        swiped = true;
        go(current + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
      }
    });
    viewport.addEventListener('pointercancel', function () { tracking = false; });
    viewport.addEventListener('click', function (e) {
      if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; }
    }, true);

    /* Auto-advance, with a visible pause button */
    function stopTimer() { if (timer) { window.clearInterval(timer); timer = null; } }
    function startTimer() {
      if (!seconds || userPaused || timer || document.hidden) return;
      timer = window.setInterval(function () { go(current + 1, 1); }, seconds * 1000);
    }
    if (seconds) {
      if (pauseBtn) {
        pauseBtn.hidden = false;
        pauseBtn.addEventListener('click', function () {
          userPaused = !userPaused;
          pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
          pauseBtn.setAttribute('aria-label', userPaused ? 'Resume automatic slides' : 'Pause automatic slides');
          if (userPaused) stopTimer(); else startTimer();
        });
      }
      root.addEventListener('mouseenter', stopTimer);
      root.addEventListener('mouseleave', startTimer);
      root.addEventListener('focusin', stopTimer);
      root.addEventListener('focusout', startTimer);
      document.addEventListener('visibilitychange', function () { if (document.hidden) stopTimer(); else startTimer(); });
      startTimer();
    }

    /* Theme editor: jump to a slide when its block is selected */
    root.addEventListener('shopify:block:select', function (e) {
      var k = slides.indexOf(e.target);
      if (k > -1) go(k);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ibb-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
